if ( body_class( 'has_wizard' ) ) {
    the_doc.ready( function() {
        // Get / set default colors
        wzrd_colors( true );
        // Set sizes
        wzrd_sizes();
        // Colorpicker init
        wzrd_colorpicker();
        // Tabs init
        wzrd_tab_select();
        // Margin init
        wzrd_margin_select();
        // Padding init
        wzrd_padding_select();
    });

    // ----------------------------

    the_win.on( 'load', function( e ) {
        // Init wizard data - after all is done loading
        wait( 750 ).then( function() {
            init_wzrd_data( e );
        });
    });

    // ----------------------------

    // Root element
    const root_elem = getComputedStyle( document.documentElement );

    // ----------------------------

    // Open wizard (toggle)
    the_doc.on( 'click', '.js_wizard_trigger', function( e ) {
        e.stopPropagation();
        let target_elem	= jQuery( '.wizard_panel' );
        target_elem.toggleClass( 'active' );
    });

    // ----------------------------

    // Read global CSS vars for sizes and set sliders accordingly
    // TODO: Make it possible to set 100% width!
    function wzrd_sizes() {
        // Size slider selector
        let get_elem = jQuery( '.js_size' );
        // Create sliders
        // NOTE: Migrated to native JS for the selector to keep it in the DOM (not wrapped in jQuery)
        get_elem.each( function() {
            let _this           = jQuery( this );
            let this_ref        = _this.attr( 'data-ref' );
            let this_id         = _this.attr( 'id' );
            let slider          = document.getElementById( this_id );
            let root_val        = root_elem.getPropertyValue( this_ref ).trim().replace( 'rem', '' );
            // Size slider
            noUiSlider.create( slider, {
                range: {
                    'min': 120,
                    'max': ( the_win.width() / 10 )
                },
                step: 10,
                // Handles start at ...
                start: root_val,
                margin: 300,
                connect: true,
                orientation: 'horizontal',
                behaviour: 'tap-drag',
                tooltips: true,
                pips: {
                    mode: 'steps',
                    density: 10
                }
            });
            // noUISlider response when set() is being called - METHOD
            slider.noUiSlider.on( 'set', function( values, handle ) {
                let this_ref        = _this.attr( 'data-ref' );
                let this_tab_ref    = _this.closest( '.subsettings' ).attr( 'data-ref' );
                let handle_size     = parseFloat( values[handle] ).toString();
                let slick_slider    = jQuery( '.js_slicked' );
                // Set root CSS values
                jQuery( ':root' ).get( 0 ).style.setProperty( this_ref, handle_size + 'rem' );
                // Parse/update local storage item values if wizard is allowed to save
                if ( wzrd_save() === true ) {
                    set_wzrd_data( this_tab_ref );
                    debug( 'wzrd_sizes()',true,'noUISlider value changed in: ' + this_tab_ref + '\n' );
                }
                // If slider is present
                if ( body_class( 'is_home' ) && slick_slider.length && typeof slick_slider !== 'undefined' ) {
                    slick_slider.slick( 'destroy' );
                    slick_slider.slick( 'init' );
                }
            });
            // noUISlider response when "change", "drag" or "end" is being fired - EVENT
            slider.noUiSlider.on( 'change.drag.end', function( values, handle ) {
                let handle_size = parseFloat( values[handle] ).toString();
                // Trigger noUiSlider set() - method
                slider.noUiSlider.set( handle_size );
            });
        });
    }

    // ----------------------------

    // Set color on change
    the_doc.on( 'change', '.js_colorpicker', function( e ) {
        let _this       = jQuery( this );
        wzrd_colors( false, true, _this );
    });

    // Init colorpicker
    function wzrd_colorpicker() {
        jQuery( '.js_colorpicker' ).each( function() {
            let _this = jQuery( this );

            _this.minicolors({
                theme: 'default'
            });
        });
    }

    // Read all colorpicker inputs and set the CSS root value automatically after init / set colors manually
    function wzrd_colors( set_init, set_new, elem ) {
        if ( set_init === true ) {
            // debug( 'wzrd_colors()',true, 'set_init' );
            let get_elem        = jQuery( '.js_colorpicker' );

            get_elem.each( function() {
                let _this       = jQuery( this );
                let this_ref    = _this.data( 'ref' );
                let this_color  = root_elem.getPropertyValue( this_ref ).trim();

                _this.val( this_color );
            });
        }

        if ( set_new === true && elem !== 'undefined' ) {
            let _this           = elem;
            let this_val        = _this.val();
            let this_ref        = _this.data( 'ref' );
            let this_tab_ref    = elem.closest( '.subsettings' ).attr( 'data-ref' );

            jQuery( ':root' ).get( 0 ).style.setProperty( this_ref, this_val );
            if ( wzrd_save() === true ) {
                set_wzrd_data( this_tab_ref );
                debug( 'wzrd_colors()', false, 'Colorpicker value changed in: ' + this_tab_ref + '\n' );
            }
        }
    }

    // ----------------------------

    // Init wizard select
    function wzrd_tab_select() {
        let target_select   = jQuery( '.js_wizard_tab_select' );
        let has_select      = target_select.length;

        if ( has_select && typeof has_select !== 'undefined' ) {
            if ( target_select.is( '.wizard_tab_select' ) ) {
                target_select.select2({
                    width: 'resolve',
                    minimumResultsForSearch: -1,
                    dropdownAutoWidth: false,
                    dropdownParent: target_select.parent()
                }).on( 'change', function( e ) {
                    let this_selected	= jQuery(this).find( 'option:selected' );
                    wzrd_sub_tabs( this_selected.val() );
                });
            }
        }
    }

    // Toggle sub tabs
    function wzrd_sub_tabs( ref ) {
        let sub_tabs      = jQuery( '.subsettings' );
        let target_tab    = jQuery( '.subsettings[data-ref="' + ref + '"]' );
        // Toggle tabs
        sub_tabs.removeClass( 'active' );
        target_tab.addClass( 'active' );
    }

    // ----------------------------

    // Init margin select
    function wzrd_margin_select( target, arg ) {
        let target_select   = jQuery( '.js_margin_select' );
        // Override the target if set
        // if ( target && typeof target !== 'undefined' ) {
        //     target_select = target;
        // }
        let has_select      = target_select.length;
        // First check if class is available
        if ( has_select && typeof has_select !== 'undefined' ) {
            if ( target_select.is( '.margin_select' ) ) {
                target_select.each( function() {
                    let _this = jQuery( this );
                    // Init the select 2 on element class
                    _this.select2({
                        width: 'resolve',
                        minimumResultsForSearch: -1,
                        dropdownAutoWidth: false,
                        dropdownParent: _this.parent()
                    }).on( 'change', function( e ) {
                        let this_selected	= _this.find( 'option:selected' ).val();
                        let this_ref        = _this.data( 'ref' );
                        // let is_slider       = _this.closest( '.subsettings[data-ref="slider"]' ).length;
                        let this_tab_ref    = _this.closest( '.subsettings' ).attr( 'data-ref' );
                        // Set new root var value
                        // Check for auto value, else set numeric value
                        if ( this_selected === 'auto' ) {
                            jQuery( ':root' ).get( 0 ).style.setProperty( this_ref, this_selected );
                        } else {
                            jQuery( ':root' ).get( 0 ).style.setProperty( this_ref, this_selected  + 'rem' );
                        }
                        // If wizard save
                        if ( wzrd_save() === true ) {
                            set_wzrd_data( this_tab_ref );
                        }
                        // Optionally check for slider
                        // if ( is_slider ) {
                        //     jQuery( '.js_slicked' ).slick( 'destroy' );
                        //     jQuery( '.js_slicked' ).slick( 'init' );
                        // }
                    });

                    // Override value if target is set
                    // if ( target && typeof target !== 'undefined' ) {
                    //     let this_selected   = arg * 10;
                    //     let this_ref        = _this.data( 'ref' );
                    //     let this_tab_ref    = _this.closest( '.subsettings' ).attr( 'data-ref' );
                    //     // Set new root var value
                    //     jQuery( ':root' ).get( 0 ).style.setProperty( this_ref, this_selected  + 'rem' );
                    //     // If wizard save
                    //     if ( wzrd_save() === true ) {
                    //         set_wzrd_data( this_tab_ref );
                    //     }
                    // }
                });
            }
        }
    }

    // Pass margin X-factor
    // the_doc.on( 'change', '.js_margin_factor', function( e ) {
    //     let _this       = jQuery( this );
    //     let this_select = _this.closest( '.margin_wrapper' ).find( '.js_margin_select' );
    //     let this_val    = this_select.find( 'option:selected' ).val();
    //     let is_checked  = _this.is( ':checked' );
    //
    //     if ( is_checked ) {
    //         wzrd_margin_select( this_select, this_val );
    //         debug( '.js_margin_factor', true, 'Margin x-factor: ' + this_val );
    //     } else {
    //         return false;
    //     }
    // });

    // ----------------------------

    // Init padding select
    function wzrd_padding_select() {
        let target_select   = jQuery( '.js_padding_select' );
        let has_select      = target_select.length;
        // First check if class is available
        if ( has_select && typeof has_select !== 'undefined' ) {
            if ( target_select.is( '.padding_select' ) ) {
                target_select.each( function() {
                    let _this = jQuery( this );
                    // Init the select 2 on element class
                    _this.select2({
                        width: 'resolve',
                        minimumResultsForSearch: -1,
                        dropdownAutoWidth: false,
                        dropdownParent: _this.parent()
                    }).on( 'change', function( e ) {
                        let this_selected	= _this.find( 'option:selected' ).val();
                        let this_ref        = _this.data( 'ref' );
                        let is_slider       = _this.closest( '.subsettings[data-ref="slider"]' ).length;
                        let this_tab_ref    = _this.closest( '.subsettings' ).attr( 'data-ref' );
                        // Set new root var value
                        // Check for auto value, else set numeric value
                        if ( this_selected === 'auto' ) {
                            jQuery( ':root' ).get( 0 ).style.setProperty( this_ref, this_selected );
                        } else {
                            jQuery( ':root' ).get( 0 ).style.setProperty( this_ref, this_selected  + 'rem' );
                        }
                        // If wizard save
                        if ( wzrd_save() === true ) {
                            set_wzrd_data( this_tab_ref );
                            debug( 'wzrd_padding_select()', false, 'Padding value changed in: ' + this_tab_ref + '\n' );
                        }
                        // Optionally check for slider
                        if ( is_slider ) {
                            jQuery( '.js_slicked' ).slick( 'destroy' );
                            jQuery( '.js_slicked' ).slick( 'init' );
                        }
                    });
                });
            }
        }
    }

    // ----------------------------

    // Upload image / render in browser

    // Account for landscape, portrait and square images (orientation)
    // jQuery( '.js_wzrd_logo_orientation' ).change( function() {
    //     let _this       = jQuery( this );
    //     let this_class = _this.attr( 'data-class' );
    //     // Set logo ratio class
    //     wzrd_change_img_orientation( this_class );
    // });

    // Handle input changes
    jQuery( '.js_wzrd_logo' ).change( function() {
        let _this       = jQuery( this );
        let this_target = _this.attr( 'data-target' );
        // Do it, go render...
        wzrd_change_img( this.files[0], this_target );
    });

    // Change the logo ratio
    // function wzrd_change_img_orientation( param ) {
    //     the_htm.removeClass( 'logo_landscape logo_square logo_portrait' );
    //     the_htm.addClass( 'logo_' + param );
    //     debug( 'wzrd_change_img_orientation()',true, 'Changed logo orientation class to: logo_' + param );
    // }

    // Calculate the logo orientation
    function wzrd_calc_img_orientation() {
        let radio_src           = jQuery( 'input.logo_orientation' );
        let radio_tar;
        // Image
        let img                 = jQuery( '.pagelogo > img' );
        let img_height          = img.height();
        let img_width           = img.width();
        // Threshold
        let threshold_limiter   = 15; // Percentage of total
        let threshold_height    = Number( img_height - (( img_height / 100 ) * threshold_limiter ));
        let threshold_width     = Number( img_width - (( img_width / 100 ) * threshold_limiter ));
        let threshold           = img_width === img_height || ( img_width <= img_height && img_width >= threshold_height ) || ( img_height <= img_width && img_height >= threshold_width );
        // Orientation
        let orientation;
        // Figure out corresponding orientation
        if ( threshold ) {
            orientation = 'square';
        } else if ( img_width > img_height && ! threshold ) {
            orientation = 'landscape';
        } else if ( img_width < img_height && ! threshold ) {
            orientation = 'portrait';
        }
        // When orientation has been detected, un-/check corresponding radio and set corresponding orientation class
        // jQuery( wzrd_change_img_orientation( orientation )).promise().done( function() {
            radio_tar = jQuery( 'input.logo_orientation[data-class="' + orientation + '"]' );
            radio_src.prop( 'checked', false );
            radio_tar.prop( 'checked', true );
        // });
        debug( 'wzrd_calc_img_orientation()', false, 'Calculated logo orientation to be: ' + orientation );
    }

    // Change the image
    function wzrd_change_img( file, tar, arg ) {
        // Prep. target
        let target;
        // Generate a new FileReader object
        let reader = new FileReader();
        // Inject an image with the src url
        reader.onload = function( e ) {
            let the_url     = e.target.result;
                target      = jQuery( '.' + tar );
            // let tar_height  = target.height();
            target.html( '<img src="' + the_url + '" alt="" title="" />' );
            // target.find( 'img' ).css( 'max-height', tar_height );
        }
        // When the file is read it triggers the onload event above.
        // jQuery( reader.readAsDataURL( file )).promise().done( function() {
        //     setTimeout(() => {
        //         wzrd_calc_img_orientation();
        //     }, 250 );
        // });
        reader.readAsDataURL( file );
    }

    // ----------------------------

    // Wizard data(set)
    // NOTE: Using local storage instead of session storage due to availability of the stored data!

    // Check for existing wizard local storage item - "boolean"
    function wzrd_save() {
        if ( localStorage.getItem( 'wzrd_save' ) !== null && localStorage.getItem( 'wzrd_save' ) === 'yes' ) {
            return true;
        } else if ( localStorage.getItem( 'wzrd_save' ) !== null && localStorage.getItem('wzrd_save' ) === 'no' ) {
            return false;
        }
    }

    // ----------------------------

    // Buttons for wizard data handling options
    the_doc.on( 'click', '.js_wzrd_action', function( e ) {
        e.preventDefault();
        e.stopPropagation();
        let _this       = jQuery( this );
        let this_ref    = _this.attr( 'data-ref' );
        // Import
        if ( this_ref === 'import' ) { import_wzrd_data( e, 'upload' ); }
        // Export
        if ( this_ref === 'export' ) { export_wzrd_data(); }
        // Clear
        if ( this_ref === 'clear' ) { clear_wzrd_data(); }
    });

    // ----------------------------

    // Listener for (hidden) wizard data import (upload) field
    the_doc.on( 'change', '#wzrd_file', function( e ) {
        import_wzrd_data( e, 'change' );
    });

    // ----------------------------

    // Init wizard data - prep. for local storage
    function init_wzrd_data( e ) {
        if ( localStorage.getItem( 'wzrd_save' ) === null ) {
            debug( 'init_wzrd_data()',true, '\n' + 'Wizard local storage data doesn\'t exist' + '\n\n' );
            // Trigger modal (GDPR)
            // NOTE: The idea behind this is to cover the GDPR aspects of consent.
            //       - We will need to store some data in the browser for reason of functionality.
            //       - No personal data will be sent over the internet for this feature.
            Swal.fire({
                icon: 'warning',
                title: GLOB_WARNING,
                html: 'Do you want to save the wizard data to local storage?',
                showDenyButton: true,
                confirmButtonText: BTN_CONTINUE,
                denyButtonText: BTN_CANCEL,
                showCloseButton: false,
                allowOutsideClick: false
            }).then(( result ) => {
                if ( result.isConfirmed ) {
                    // Create wizard data - yes
                    localStorage.setItem( 'wzrd_save', 'yes' );
                    debug( 'init_wzrd_data()',true, '\n' + 'Wizard local storage data will now be saved' + '\n' + 'Triggering set wizard data function ...' + '\n\n' );
                    // Trigger set wizard data function
                    set_wzrd_data();
                } else {
                    // Delete wizard data - no
                    localStorage.setItem( 'wzrd_save', 'no' );
                    debug( 'init_wzrd_data()',true, '\n' + 'Wizard data ignored' + '\n\n' );
                }
            })
        } else if ( wzrd_save() === true ) {
            debug( 'init_wzrd_data()',true, '\n' + 'Wizard local storage data available, ready for action!' + '\n\n' );
            // Load local storage wizard data
            load_wzrd_data( e, read_wzrd_data( 'all' ), 'local' );
        } else if ( wzrd_save() === false ) {
            debug( 'init_wzrd_data()',true, '\n' + 'Wizard data ignored' + '\n\n' );
        }
        // For debug only!
        localStorage.setItem( 'test_item', 'DEBUG: To show deleting wizard data doesn\'t remove this item....' );
    }

    // Set wizard data
    function set_wzrd_data( arg, json_data ) {
        // First, make sure we are allowed to store local storage data
        if ( wzrd_save() === true ) {
            // Temporary object(s) dump ...
            let data_prep = [];
            // Target selector(s) for iteration
            let target_wrapper = jQuery( '.wizard_wrapper .subsettings' );
            // Specific target iteration
            if ( arg ) {
                target_wrapper = jQuery( '.wizard_wrapper .subsettings[data-ref="' + arg + '"]' );
            }
            // Iterate through each subsettings tab
            jQuery.each( target_wrapper, function() {
                let _this                   = jQuery( this );
                let this_tab_ref            = _this.attr( 'data-ref' );
                let this_size_slider        = _this.find( '.js_size' );
                let this_size_ref           = this_size_slider.attr( 'data-ref' );
                let this_colorpicker        = _this.find( '.js_colorpicker' );
                let this_colorpicker_ref    = this_colorpicker.attr( 'data-ref' );
                let this_padding            = _this.find( '.js_padding_select' );
                let this_padding_ref        = this_padding.attr( 'data-ref' );
                let this_margin             = _this.find( '.js_margin_select' );
                let this_margin_ref         = this_margin.attr( 'data-ref' );
                // Slider size
                if ( this_size_slider.length && typeof this_size_slider !== 'undefined' ) {
                    let size_slider = [];

                    if ( this_size_slider.length === 1 ) {
                        let this_size_val = this_size_slider.find( '.noUi-handle > .noUi-tooltip' ).text();
                            this_size_val = this_size_val.replace( '.00', '' );
                        size_slider.push( this_size_ref + ':' + this_size_val );
                    } else if ( this_size_slider.length > 1 ) {
                        jQuery.each( this_size_slider, function() {
                            let _this         = jQuery( this );
                            let this_size_val = _this.find( '.noUi-handle > .noUi-tooltip' ).text();
                                this_size_val = this_size_val.replace( '.00', '' );
                                this_size_ref = _this.attr( 'data-ref' );
                            size_slider.push( this_size_ref + ':' + this_size_val );
                        });
                    }
                    data_prep.push( size_slider );
                }
                // Color(picker)
                if ( this_colorpicker.length && typeof this_colorpicker !== 'undefined' ) {
                    let color = [];

                    if ( this_colorpicker.length === 1 ) {
                        let this_colorpicker_val = this_colorpicker.val();
                        color.push( this_colorpicker_ref + ':' + this_colorpicker_val );
                    } else if ( this_colorpicker.length > 1 ) {
                        jQuery.each( this_colorpicker, function() {
                            let _this                 = jQuery( this );
                            let this_colorpicker_val  = _this.val();
                                this_colorpicker_ref  = _this.attr( 'data-ref' );
                            color.push( this_colorpicker_ref + ':' + this_colorpicker_val );
                        });
                    }
                    data_prep.push( color );
                }
                // Margin
                if ( this_margin.length && typeof this_margin !== 'undefined' ) {
                    let margin = [];
                    if ( this_margin.length === 1 ) {
                        let this_margin_val = this_margin.val();

                        debug( 'set_wzrd_data()', false, 'Detected margin single: ' + this_margin_ref + ':' + this_margin_val );

                        margin.push( this_margin_ref + ':' + this_margin_val );
                    } else if ( this_margin.length > 1 ) {
                        jQuery.each( this_margin, function() {
                            let _this               = jQuery( this );
                            let this_margin_val     = _this.val();
                                this_margin_ref     = _this.attr( 'data-ref' );

                            debug( 'set_wzrd_data()', false, 'Detected margin multiple: ' + this_margin_ref + ':' + this_margin_val );

                            margin.push( this_margin_ref + ':' + this_margin_val );
                        });
                    }

                    data_prep.push( margin );
                }
                // Padding
                if ( this_padding.length && typeof this_padding !== 'undefined' ) {
                    let padding = [];

                    if ( this_padding.length === 1 ) {
                        let this_padding_val = this_padding.val();
                        padding.push( this_padding_ref + ':' + this_padding_val );
                    } else if ( this_padding.length > 1 ) {
                        jQuery.each( this_padding, function() {
                            let _this               = jQuery( this );
                            let this_padding_val    = _this.val();
                                this_padding_ref    = _this.attr( 'data-ref' );
                            padding.push( this_padding_ref + ':' + this_padding_val );
                        });
                    }
                    data_prep.push( padding );
                }
                // Flatten nested array - removing unwanted code complexity - since we will only be needing simple key-value pairs for later processing
                let local_data = data_prep.flat();
                    local_data = JSON.stringify( local_data );
                // Dump array into local storage wizard item (single or all)
                localStorage.setItem( 'wzrd_' + this_tab_ref, local_data );
                // Empty array object(s) before next iteration ...
                data_prep = [];
            });
        }
    }

    // Read / clear all relevant wizard local storage data - object
    // NOTE: This is used for later populating each subsetting tab with stored values
    function read_wzrd_data( arg, target ) {
        if ( wzrd_save() === true ) {
            // Create objects for local storage items
            let items = {};
            let keys    = Object.keys( localStorage );
            let i       = keys.length;
            // Read / prep. data first
            if ( arg && typeof arg !== 'undefined' ) {
                // Loop through all items
                while ( i-- ) {
                    // NOTE: Only grab local storage items containing wizard related data
                    if ( keys[i].indexOf( 'wzrd_' ) !== -1 && keys[i] !== 'wzrd_save' ) {
                        items[ keys[i] ] = localStorage.getItem( keys[i] );
                    }
                }
                // Loop through all items and disregard unneeded ones - return items
                if ( arg === 'all' ) {
                    return items;
                // Get values for single object (subsettings tab)
                } else if ( arg === 'single' && target && typeof target !== 'undefined' ) {
                    // Empty array first
                    items = {};
                    // Populate array with new data
                    items[keys[0]] = localStorage.getItem( 'wzrd_' + target );
                    // Return single item
                    return items;
                }
            }
        }
    }

    // Set wizard data
    // TODO: When "global" is being parsed it will throw a JS error due to the fact that it's a CSS root variable used
    //       by mutliple elements, this in turn collides with the custom settings per subsettings tab.
    //       So we need to create a "fake" global override function - DISABLED for now ...
    function load_wzrd_data( e, json_data, arg ) {
        if ( json_data && typeof json_data !== 'undefined' && arg && typeof arg !== 'undefined' ) {
            // Uploaded file
            if ( arg === 'upload' ) {
                debug( 'load_wzrd_data()',true,'Loading wizard data from upload' + '\n\n' );
            }
            // Local storage
            if ( arg === 'local' ) {
                debug( 'load_wzrd_data()',true,'Loading wizard data from local storage' + '\n\n' );
            }
            // Dynamically iterate through JSON object as we have no specific keyname(s) to target
            // However, we DO know the object's structure
            jQuery.each( json_data, function( key, value ) {
                // Subsetting tab name (strip prefix)
                let tab = key.replace( 'wzrd_', '' );
                debug( 'load_wzrd_data()',true, 'Subsettings for: ' + tab );
                // Flatten nested arrays
                let sub_object = JSON.parse( value );
                    sub_object = sub_object.flat();
                // Iterate through (each subsetting) data
                jQuery.each( sub_object, function( key, value ) {
                    // Set target tab we need to apply changes to
                    let this_target_parent      = jQuery( '.subsettings[data-ref="' + tab + '"]' );
                    // Lastly, knowing we have the end result, split it and grab the new values
                    let [this_root, this_val]   = value.split( ':' );
                    let this_target_node        = this_target_parent.find( '[data-ref="' + this_root + '"]' );
                    let this_target_type        = this_target_node.prop( 'nodeName' ).toLowerCase();
                    let this_target_class       = this_target_node.attr( 'class' );
                    // Debug
                    debug( 'load_wzrd_data()',true, 'Target node is: "' + this_target_type + '", with data-ref: "' + this_root + '", and value: "' + this_val + '"' );
                    // Filter on nodes
                    if ( this_target_node.length ) {
                        if ( this_target_type === 'input' ) {
                            if ( this_target_class.indexOf( 'color' ) !== -1 ) {
                                // Set new value for the colorpicker lib.
                                this_target_node.minicolors();
                                this_target_node.minicolors( 'value', this_val );
                            }
                        } else if ( this_target_type === 'select' ) {
                            if ( this_target_class.indexOf( 'padding') !== -1 ) {
                                // Set the new value for the select2 lib.
                                this_target_node.val( this_val );
                                this_target_node.trigger( 'change' );
                            } else if ( this_target_class.indexOf( 'margin') !== -1 ) {
                                // Set the new value for the select2 lib.
                                this_target_node.val( this_val );
                                this_target_node.trigger( 'change' );
                            }
                        } else if ( this_target_type === 'div' ) {
                            if ( this_target_class.indexOf('size') !== -1 ) {
                                let this_id = this_target_node.attr( 'id' );
                                let slider  = document.getElementById( this_id );
                                // Set the new value for the noUISlider lib.
                                slider.noUiSlider.set( this_val );
                            }
                        }
                    }
                });
                debug( 'load_wzrd_data()',true, '\n\n' );
            });
        }
    }

    // Import wizard data
    function import_wzrd_data( e, arg ) {
        let this_input = jQuery( '#wzrd_file' );
        let this_value = this_input.val();
        // Show wizard file upload dialogue
        if ( arg === 'upload' ) {
            debug( 'import_wzrd_data()',true, '\n\n' + 'Opening wizard JSON file upload dialogue' + '\n' );
            this_input.click();
        }
        // Process wizard JSON file data on change event
        if ( arg === 'change' ) {
            // Continue only when there is file data
            if ( this_value.length ) {
                debug( 'import_wzrd_data()',true, 'Handling wizard JSON file data ...' + '\n' );
                // Start new filereader object
                let reader = new FileReader();
                // Read file contents as text
                reader.readAsText( this_input[0].files[0] );
                // Output
                reader.onload = function( e ) {
                    let data  = e.target;
                        data  = JSON.parse( data.result );
                    // Process the data, hand it over to dedicated function
                    load_wzrd_data( e, data, 'upload' );
                }
            }
        }
    }

    // Export wizard data
    // NOTE: All JSON objects will be exported as stringified data
    function export_wzrd_data() {
        let this_data       = read_wzrd_data( 'all' );
        let this_json       = JSON.stringify( this_data );
        let this_data_uri   = 'data:application/json;charset=utf-8,' + encodeURIComponent( this_json );
        let this_filename   = 'wzrd_data.json';
        let tmp_link        = document.createElement( 'a' );
        // Prep. tmp link and trigger click to initiate the export
        tmp_link.setAttribute('href', this_data_uri );
        tmp_link.setAttribute('download', this_filename );
        tmp_link.click();
        // debug( 'export_wzrd_data()',true, 'Function for exporting wizard data triggered' + '\n' );
        debug( 'export_wzrd_data()',true, 'Exported data as "' + typeof( this_json ) + '": \n' + this_json );
    }

    // Clear wizard data
    function clear_wzrd_data() {
        if ( localStorage.getItem( 'wzrd_save' ) !== null && ( wzrd_save() === true || wzrd_save() === false )) {
            let keys    = Object.keys( localStorage );
            let i       = keys.length;
            // Trigger modal
            Swal.fire({
                icon: 'warning',
                title: GLOB_WARNING,
                html: 'Do you want to remove ALL wizard data from local storage?',
                showDenyButton: true,
                confirmButtonText: BTN_CONTINUE,
                denyButtonText: BTN_CANCEL,
                showCloseButton: false,
                allowOutsideClick: false
            }).then(( result ) => {
                // Confirm
                if ( result.isConfirmed ) {
                    // Clear all wizard related data from local storage
                    while ( i-- ) {
                        // NOTE: Only grab local storage items containing (specific) subsettings related data
                        if ( keys[i].indexOf( 'wzrd_' ) !== -1 ) {
                            localStorage.removeItem( keys[i] );
                        }
                    }
                    // Show confirmation toast
                    // toast_title     = GLOB_SUCCESS;
                    // toast_content   = 'ALL wizard data has been cleared!';
                    // toast_icon      = 'success';
                    // Show toast
                    // do_toast( toast_title, toast_content, toast_icon, 3000, '', true );

                    toast_title     = GLOB_SUCCESS;
                    toast_content   = 'ALL wizard data has been cleared!';
                    toast_icon      = 'success';
                    do_toast( toast_title, toast_content, toast_icon, 600000, '', true, 'modal_clone', true, BTN_CONTINUE );

                    // Debug
                    debug( 'clear_wzrd_data()',true, 'Wizard local storage data cleared' + '\n' );
                    debug( 'clear_wzrd_data()',true, '\n\n' );
                }
            })
        // No wizard data can be found or wizard data is being ignored
        } else if ( localStorage.getItem( 'wzrd_save' ) === null ) {
            // Show no data toast
            // toast_title     = GLOB_ATTENTION;
            // toast_content   = 'NO wizard data currently available.';
            // toast_icon      = 'info';
            // Confirmation toast
            // do_toast( toast_title, toast_content, toast_icon, 4500, '', true );

            toast_title     = GLOB_ATTENTION;
            toast_content   = 'NO wizard data currently available.';
            toast_icon      = 'info';
            do_toast( toast_title, toast_content, toast_icon, 600000, '', true, 'modal_clone', true, BTN_CONTINUE );
        }
    }

    // Before unload, notify user regarding wizard settings
    the_win.on( 'beforeunload', function() {
        // Trigger modal - Are you sure you want to leave / clear data?
        // clear_wzrd_data();
    });

    // Unload and delete all wizard stuff
    the_win.on( 'unload', function() {
        // Do something ...
    });
}